import { Title } from '@angular/platform-browser';
import { SharedSfxService } from './../../../../../../shared/services/shared-sfx.service';
import { PortalViewPageStatusEnum } from './../../shared-portal-view.service';
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PromptingService } from 'src/app/shared/services';
import { SharedPortalViewService } from '../../shared-portal-view.service';
import { PageItem } from '../../../../../../models/portal';
import { ApiService } from '../../../../../../shared/services/lsg.api.service';
import { Observable, last, lastValueFrom, map } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { DivStateAnimation } from '../../../../../../shared/animations/animations';
import { WebsiteModel } from '../../../portal.model';
import { Store } from '@ngrx/store';
import {
  isWebsiteLoaded,
  isWebsitePagesLoaded,
  selectWebsite,
  selectWebsitePages,
} from 'src/app/shared/store/_features/website/website.selector';
import { websitePagesActions } from 'src/app/shared/store/_features/website/website.actions';

@Component({
  selector: 'app-portal-pages',
  templateUrl: './portal-pages.component.html',
  styleUrls: ['./portal-pages.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.5s ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('shrinkOut', [
      state('in', style({})),
      transition('* => void', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition('void => true', [
        style({ transform: 'translateX(-150px)', opacity: 0 }),
        animate(400, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    trigger('shrinkOutOnlyIn', [
      state('in', style({})),
      transition('void => *', [
        style({ transform: 'translateX(250px)', opacity: 0 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    DivStateAnimation,
  ],
})
export class WebsitePagesComponent implements OnInit {
  website$: Observable<WebsiteModel>;
  isWebsiteLoaded$: Observable<boolean>;

  websitePages$: Observable<PageItem[]>;
  isWebsitePagesLoaded$: Observable<boolean>;

  userWebsitePages: PageItem[];
  WebsitePagesScreenshots: string[];
  WebsitePagesScreenshotsLoad: boolean[];

  // UI Tools
  bonk: HTMLAudioElement = new Audio('assets/bonk.mp3');
  crumbling: HTMLAudioElement = new Audio('assets/paper-crumbling.mp3');

  constructor(
    public sharedPortalViewService: SharedPortalViewService,
    public api: ApiService,
    private route: Router,
    public sharedSfxService: SharedSfxService,
    private title: Title,
    private store: Store,
    private prompting: PromptingService,
  ) {
    this.sharedPortalViewService.setPageStatus(PortalViewPageStatusEnum.pages);
    this.handleScreenshotError = this.handleScreenshotError.bind(this);

    this.website$ = this.store.select(selectWebsite);
    this.isWebsiteLoaded$ = this.store.select(isWebsiteLoaded);

    this.websitePages$ = this.store.select(selectWebsitePages);
    this.isWebsitePagesLoaded$ = this.store.select(isWebsitePagesLoaded);
  }

  async ngOnInit() {
    this.getPages();
    // this.website$.pipe(last()).subscribe(async lastValue => {
    //   this.sharedPortalViewService.startLoading();

    // await this.getPages(lastValue.id);
    // this.sharedPortalViewService.stopLoading();
    // this.title.setTitle(
    //   this.sharedPortalViewService.currentWebsite.website.label + ' > ' + 'Pages'
    // );
    // });
  }

  async getPages(id: number = this.sharedPortalViewService.currentWebsite.id) {
    this.store.dispatch(websitePagesActions.load({}));
    // // TODO: Configuration Wordpress Pages API Call
    // // Payouts Functions
    // let pages$ = this.api.getWebsitePages(id);
    // let pages: PageItem[] = await lastValueFrom(pages$);

    // // const WebsitePages = await this.api.getWebsitePages(id).toPromise();
    // pages.forEach((page) => {
    //   page.modifiedParse = Date.parse(page.modified);
    // });
    // // this.userWebsitePages = WebsitePages.sort((a,b) => Date.parse(b.modified) - Date.parse(a.modified));
    // this.sharedPortalViewService.currentWebsite.pages = pages;

    // this.WebsitePagesScreenshotsLoad = new Array(
    //   this.sharedPortalViewService.currentWebsite.pages.length
    // ).fill(false);
    // this.WebsitePagesScreenshots = new Array(
    //   this.sharedPortalViewService.currentWebsite.pages.length
    // ).fill(false);

    // this.queuePortalImages();
  }

  // async queuePortalImages() {
  //   this.sharedPortalViewService.currentWebsite?.pages.forEach(async (page) => {
  //     page.screenshot = await this.callScreenShot(
  //       page.link.toString(),
  //       false,
  //       false
  //     );
  //   });
  // }

  async callScreenShot(url: string, fullPage: boolean, https: boolean = true) {
    if (!!https) {
      url = 'https://' + url;
    }
    const img$ = this.api.screenshot(url, fullPage, this.handleScreenshotError);
    const img = await lastValueFrom(img$);
    return img.img;
  }

  private handleScreenshotError(error: HttpErrorResponse) {
    const msg = 'Something went wrong in portal service.';
    // return an observable with a user friendly message
    return error.message || msg;
  }

  // Pages Function
  async DeletePage(page: PageItem) {
    const id = this.sharedPortalViewService.currentWebsite.id;
    const pageArrayID =
      this.sharedPortalViewService.currentWebsite.pages.findIndex(
        (a) => a.id === page.id,
      );

    this.prompting.confirm(
      {
        allowOutsideClick: false,
        input: 'checkbox',
        inputPlaceholder:
          'I confirm that I want to Delete ' + page.title + ' Page.',
        title: 'You’re about to Delete a Page',
        html:
          "<br><span style='font-size:1.2em'>Are you sure you want to Delete</span><br> " +
          page.title +
          ` <br>
        <span class='badge badge-light-danger text-danger badge-lg mt-3' style='text-transform:uppercase'>
        <i class="ler-duotone ler-trash text-danger fs-2 me-2">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
        </i> this step cannot be undone
        </span>`,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.sharedSfxService.playBonk();
          return lastValueFrom(this.api.deletePage(+id, page.id)).then(
            async (resultFromReq: any) => {
              if (resultFromReq && !!resultFromReq.success) {
                this.prompting.close();
                this.sharedSfxService.playCrumble();
                this.sharedPortalViewService.currentWebsite.pages.splice(
                  pageArrayID,
                  1,
                );
                this.refreshPagesArray();
              }
              return undefined;
            },
          );
        },
        inputValidator: (result) => {
          return !result && 'You need to agree';
        },
        didOpen: () => {
          const confirmButton =
            this.prompting.getConfirmButton() as HTMLButtonElement;
          const checkbox = this.prompting.getInput() as HTMLInputElement;

          if (confirmButton && checkbox) {
            confirmButton.disabled = !checkbox.checked;
            checkbox.addEventListener('change', () => {
              confirmButton.disabled = !checkbox.checked;
            });
          }
        },
        isDanger: true,
      },
      'lg',
    );
  }
  refreshPagesArray() {
    this.sharedPortalViewService.currentWebsite.pages = [].concat(
      this.sharedPortalViewService.currentWebsite.pages,
    );
  }

  // Page Edit Functions
  submitMyPageForm(i) {
    // const myform = document.getElementById(i) as HTMLFormElement;
    // myform.submit();
  }

  encodeRedirect(url) {
    return encodeURIComponent(url);
  }

  consoleHandler(data: any) {}
}
